import { useContext } from 'react';

import type { MembershipBottomBannerData } from '#src/app/shared/api/membership';

import { MembershipBottomBannerDataContext } from './context';

export function useMembershipBottomBannerData(): MembershipBottomBannerData {
	const context = useContext(MembershipBottomBannerDataContext);
	if (!context) {
		throw new Error('useMembershipBottomBannerData must be used within a MembershipBottomBannerDataProvider');
	}
	return context;
}
